import { Suspense } from "react";
import AdminTournamentList from "../../components/admin/AdminTournamentsList.jsx"
import { Link } from "react-router-dom";

export default function TournamentListPage() {
  return (
    <section className="m-8">
      <div className="flex flex-row w-full">
        <h1 className="w-1/2">List of Tournaments</h1>
        <div className="w-1/2 text-end">
          <Link className="text-blue-500 underline hover:no-underline text-sm" to="/cocofantoelefanto/tournaments/new">Create New Tournament</Link>
        </div>
      </div>

      <div id="teams" className={`w-full pt-4'`}>
        <Suspense fallback={<p>Carregando...</p>}>
          <AdminTournamentList />
        </Suspense>
      </div>
    </section>
  )
}
